<template>
  <div>
    <h2 class="step-name">Client</h2>

    <div class="step-section">
      <text-input label="Client Code" field-name="client_code" disabled> </text-input>

      <text-input label="Company" field-name="company" disabled> </text-input>

      <text-input label="Name" field-name="full_name" disabled> </text-input>

      <text-input label="Farm Group Name" field-name="farm_group_name" disabled> </text-input>

      <text-input label="Zone" field-name="zone" disabled> </text-input>

      <text-input label="Address" field-name="full_address" disabled> </text-input>

      <text-input label="Keyvets" field-name="keyvets" disabled> </text-input>

      <text-area label="Tags" field-name="tags" disabled> </text-area>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'Client',
  mixins: [baseComponent],
}
</script>
